import { queryKey } from '../constants/queryClientKey';
import {
  getDashboardExamByRadiologist,
  getDashboardPerformByRadiologist,
} from '../apis/dashboard';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

export function useGetDashboardExamByRadiologist(
  params: Parameters<typeof getDashboardExamByRadiologist>[0],
  options?: UseQueryOptions
) {
  return useQuery(
    [queryKey.dashboard_exam_by_radiologist, sortObjectKeys(params)],
    () => getDashboardExamByRadiologist(params),
    {
      ...options,
    }
  ) as UseQueryResult<Awaited<ReturnType<typeof getDashboardExamByRadiologist>>>;
}

export function useGetDashboardPerformByRadiologist(
  params: Parameters<typeof getDashboardPerformByRadiologist>[0],
  options?: UseQueryOptions
) {
  return useQuery(
    [queryKey.dashboard_perform_by_radiologist, sortObjectKeys(params)],
    () => getDashboardPerformByRadiologist(params),
    {
      ...options,
    }
  ) as UseQueryResult<Awaited<ReturnType<typeof getDashboardPerformByRadiologist>>>;
}
